import { useEffect } from 'react';
import AppLayout from '@/components/layout/AppLayout';
import { useWarehouseStore } from '@/stores/useWarehouseStore';
import { WarehouseStatusCards } from '@/components/admin/WarehouseStatusCards';
import { WarehouseActions } from '@/components/admin/WarehouseActions';
import { PortfolioPerformanceTable } from '@/components/admin/PortfolioPerformanceTable';
import { PermissionGate } from '@/components/acl/PermissionGate';
import * as Sentry from '@sentry/react';

const Warehouse = () => {
  const {
    etlStatus,
    portfolioPerformance,
    loading,
    loadETLStatus,
    loadPortfolioPerformance,
    runDimensions,
    runFactsIncremental,
    refreshMarts,
  } = useWarehouseStore();

  useEffect(() => {
    loadETLStatus();
    loadPortfolioPerformance();
  }, [loadETLStatus, loadPortfolioPerformance]);

  const handleRunDimensions = () => {
    Sentry.addBreadcrumb({
      category: 'warehouse',
      message: 'Running dimensions ETL',
      level: 'info',
    });
    runDimensions();
  };

  const handleRunFacts = () => {
    Sentry.addBreadcrumb({
      category: 'warehouse',
      message: 'Running facts incremental ETL',
      level: 'info',
    });
    runFactsIncremental();
  };

  const handleRefreshMarts = () => {
    Sentry.addBreadcrumb({
      category: 'warehouse',
      message: 'Refreshing marts',
      level: 'info',
    });
    refreshMarts();
  };

  return (
    <AppLayout>
      <div className="container mx-auto py-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Data Warehouse</h1>
          <p className="text-muted-foreground">
            Production analytics layer with star-schema warehouse and ETL monitoring
          </p>
        </div>

        <WarehouseStatusCards etlStatus={etlStatus} />

        <PermissionGate permission="warehouse.run">
          <WarehouseActions
            onRunDimensions={handleRunDimensions}
            onRunFacts={handleRunFacts}
            onRefreshMarts={handleRefreshMarts}
            loading={loading}
          />
        </PermissionGate>

        <PortfolioPerformanceTable data={portfolioPerformance} />
      </div>
    </AppLayout>
  );
};

export default Warehouse;
